import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Heart, Gift, AlertCircle, Sparkles } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { BonusCard } from '../components/BonusCard';
import { TestimonialCard } from '../components/TestimonialCard';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { ResultsCarousel } from '../components/ResultsCarousel';
import { DemoVideo } from '../components/DemoVideo';
import { FAQ } from '../components/FAQ';
import { Flame, Clock, ShieldCheck, Zap, Layout, BookOpen } from 'lucide-react';
export function LandingPage() {
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 4,
          minutes: 59,
          seconds: 0
        }; // Reset loop
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-pink-50 via-purple-50 to-blue-50 font-sans text-gray-800 overflow-x-hidden" data-id="element-71">
      <SocialProofPopup data-id="element-72" />

      {/* 1) Header Promocional - Compact Two Lines */}
      <div className="bg-gradient-to-r from-pink-100 via-purple-100 to-pink-100 text-purple-900 py-1 text-center sticky top-0 z-50 shadow-sm border-b border-purple-200" data-id="element-73">
        <div className="flex flex-col items-center justify-center gap-0.5 px-2" data-id="element-74">
          <div className="text-[11px] md:text-xs font-bold" data-id="element-75">
            ÚLTIMAS HORAS: 60% DE DESCUENTO + BONOS GRATIS
          </div>
          <div className="text-[10px] md:text-xs font-medium text-red-600" data-id="element-76">
            Quedan solo 3 cupos con el 60% OFF
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <header className="relative pt-8 pb-12 px-4 md:pt-20 md:pb-32 overflow-hidden" data-id="element-77">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-30" data-id="element-78">
          <div className="absolute top-10 left-10 w-32 h-32 bg-pink-300 rounded-full blur-3xl" data-id="element-79"></div>
          <div className="absolute bottom-10 right-10 w-64 h-64 bg-blue-300 rounded-full blur-3xl" data-id="element-80"></div>
          <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-purple-300 rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2" data-id="element-81"></div>
        </div>

        <div className="max-w-6xl mx-auto flex flex-col-reverse md:grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-82">
          <motion.div initial="hidden" animate="visible" variants={fadeInUp} transition={{
          duration: 0.6
        }} className="text-center md:text-left" data-id="element-83">
            {/* 1) Prueba Social en el HERO (parte superior) - Compact Pill Style */}
            <div className="flex justify-center md:justify-start mb-6" data-id="element-84">
              <div className="inline-flex items-center gap-3 bg-white/90 backdrop-blur-sm px-4 py-1.5 rounded-full border border-purple-100 shadow-sm" data-id="element-85">
                <div className="flex -space-x-2" data-id="element-86">
                  {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-6 h-6 rounded-full border border-white bg-gray-200 overflow-hidden" data-id="element-87">
                      <img src={`https://randomuser.me/api/portraits/women/${30 + i}.jpg`} alt="User" className="w-full h-full object-cover" data-id="element-88" />
                    </div>)}
                </div>
                <div className="flex items-center gap-1.5" data-id="element-89">
                  <div className="flex" data-id="element-90">
                    {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3 h-3 text-yellow-400 fill-yellow-400" data-id="element-91" />)}
                  </div>
                  <span className="text-xs font-bold text-gray-800" data-id="element-92">
                    4.9/5 (+1200 decoradoras)
                  </span>
                </div>
              </div>
            </div>

            <div className="inline-block bg-white/80 backdrop-blur-sm px-4 py-2 rounded-full text-purple-700 font-bold text-sm mb-4 shadow-sm border border-purple-100" data-id="element-93">
              ✨ Convertite en una Decoradora Profesional
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-4" data-id="element-94">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600" data-id="element-95">
                Mega Pack Globología
              </span>{' '}
              <br data-id="element-96" />
              Mágica Pro
            </h1>

            {/* Subtítulo antes del mockup en mobile */}
            <p className="text-lg md:text-xl text-gray-600 mb-6 leading-relaxed" data-id="element-97">
              Descubrí el paso a paso completo para dejar de improvisar y
              empezar a cobrar como profesional. Eventos completos con globos y
              Candy Bar.
            </p>

            {/* Mobile Image - Visible only on mobile, immediately after subtitle */}
            <div className="block md:hidden mb-6 relative" data-id="element-98">
              <div className="absolute inset-0 bg-gradient-to-tr from-pink-200 to-blue-200 rounded-3xl transform rotate-3 scale-105 blur-lg opacity-50" data-id="element-99"></div>
              <a href="http://checkout.pixastore.online/cart/42176617414750:1" target="_blank" rel="noopener noreferrer" data-id="element-100">
                <img src="https://cdn.magicpatterns.com/uploads/49wrS87uRwKRB2omP5cojj/Imagen_Portada.png" alt="Mega Pack Globología Mágica Pro" className="relative rounded-3xl shadow-2xl w-full hover:scale-[1.02] transition-transform duration-300 cursor-pointer" data-id="element-101" />
              </a>
            </div>

            {/* Chips */}
            <div className="flex flex-wrap gap-2 mb-8 justify-center md:justify-start" data-id="element-102">
              {['🎈 Decoración de eventos', '🛍 Emprendedoras', '🎉 Candy Bar', '💰 Ingresos extra'].map((tag, i) => <span key={i} className="bg-white/80 backdrop-blur-sm text-purple-800 text-xs font-bold px-3 py-1.5 rounded-full border border-purple-100 shadow-sm" data-id="element-103">
                  {tag}
                </span>)}
            </div>

            {/* 5) CTA Principal Mejorado */}
            <div className="flex flex-col items-center md:items-start gap-4" data-id="element-104">
              <CTAButton className="w-full md:w-auto" data-id="element-105">
                QUIERO MI MEGA PACK AHORA
              </CTAButton>
              <p className="text-sm text-gray-500 font-medium" data-id="element-106">
                Acceso inmediato — Garantía de 7 días
              </p>
              <div className="flex gap-4 text-xs font-bold text-purple-700" data-id="element-107">
                <span className="flex items-center gap-1" data-id="element-108">
                  ⚡ Descarga inmediata
                </span>
                <span className="flex items-center gap-1" data-id="element-109">🔒 Pago seguro</span>
                <span className="flex items-center gap-1" data-id="element-110">
                  ♻️ Garantía 7 días
                </span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: 2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 0.8
        }} className="relative hidden md:block" data-id="element-111">
            <div className="absolute inset-0 bg-gradient-to-tr from-pink-200 to-blue-200 rounded-3xl transform rotate-3 scale-105 blur-lg opacity-50" data-id="element-112"></div>
            <a href="http://checkout.pixastore.online/cart/42176617414750:1" target="_blank" rel="noopener noreferrer" data-id="element-113">
              <img src="https://cdn.magicpatterns.com/uploads/49wrS87uRwKRB2omP5cojj/Imagen_Portada.png" alt="Mega Pack Globología Mágica Pro" className="relative rounded-3xl shadow-2xl w-full hover:scale-[1.02] transition-transform duration-300 cursor-pointer" data-id="element-114" />
            </a>
          </motion.div>
        </div>
      </header>

      {/* 0) COMPRESIÓN Y FUSIÓN DE SECCIONES */}
      <section className="py-16 px-4 bg-white relative" data-id="element-115">
        <div className="max-w-4xl mx-auto" data-id="element-116">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="text-center" data-id="element-117">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-118">
              ¿Te piden un evento… y lo primero que sentís es{' '}
              <span className="text-pink-600" data-id="element-119">miedo</span>?
            </h2>

            <div className="bg-red-50 p-8 rounded-2xl border border-red-100 mb-10 text-left md:text-center" data-id="element-120">
              <p className="font-medium text-lg text-gray-700 mb-4" data-id="element-121">
                Miedo a comprar mal, a combinar colores que no funcionen, a
                tardar demasiado o a que no quede prolijo.
              </p>
              <p className="font-bold text-xl text-red-800" data-id="element-122">
                Y sobre todo, miedo a decir un precio… y sentir que estás
                improvisando.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 items-center mb-12 text-left" data-id="element-123">
              <div data-id="element-124">
                <h3 className="text-xl font-bold text-purple-900 mb-4" data-id="element-125">
                  La diferencia entre improvisar y ser profesional
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-126">
                  Hay decoradoras que trabajan tranquilas, seguras y cobran sin
                  dudar. No tienen más talento que vos, simplemente{' '}
                  <strong data-id="element-127">tienen un método.</strong>
                </p>
                <p className="text-gray-600" data-id="element-128">
                  Sin un sistema, cada evento es una apuesta. Con el Mega Pack,
                  tenés el paso a paso para dejar de dudar.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-129">
                <ul className="space-y-3" data-id="element-130">
                  {['¿Qué estructura conviene usar?', '¿Cuántos globos comprar?', '¿Cómo combinar colores?', '¿Cómo cobrar sin culpa?'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700 font-medium" data-id="element-131">
                      <AlertCircle className="w-5 h-5 text-pink-500 flex-shrink-0" data-id="element-132" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Solution Section (Compressed) */}
      <section className="py-16 px-4 bg-gradient-to-b from-purple-900 to-indigo-900 text-white" data-id="element-133">
        <div className="max-w-5xl mx-auto text-center" data-id="element-134">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-135">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-pink-300 to-purple-300" data-id="element-136">
              El problema no son los globos, es la falta de un sistema.
            </h2>

            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/20 shadow-2xl relative overflow-hidden mt-8" data-id="element-137">
              <div className="flex justify-center mb-6" data-id="element-138">
                <div className="bg-pink-500 text-white font-bold px-6 py-2 rounded-full text-sm shadow-lg" data-id="element-139">
                  LA SOLUCIÓN DEFINITIVA
                </div>
              </div>

              <h3 className="text-4xl md:text-6xl font-extrabold mb-6 text-white drop-shadow-lg" data-id="element-140">
                Mega Pack Globología Mágica Pro
              </h3>
              <p className="text-lg mb-8 text-purple-100 max-w-2xl mx-auto" data-id="element-141">
                Un pack digital completo donde aprendés a convertir la
                globología y la decoración de eventos en un servicio rentable,
                ordenado y profesional.
              </p>

              <CTAButton className="w-full md:w-auto text-purple-900 bg-white hover:bg-gray-100 border-none" data-id="element-142">
                QUIERO MI MEGA PACK AHORA
              </CTAButton>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Results Carousel Section */}
      <section className="py-20 px-4 bg-white" data-id="element-143">
        <div className="max-w-6xl mx-auto" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-145">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-146">
              Este es el tipo de eventos que vas a poder armar con el método.
            </h2>
            <p className="text-gray-600" data-id="element-147">
              Resultados reales y alcanzables para quienes están aprendiendo
            </p>
          </motion.div>
          <ResultsCarousel data-id="element-148" />
          <DemoVideo data-id="element-149" />

          {/* 6) Sección "Qué vas a poder hacer" (Mejorada) */}
          <div className="mt-20 max-w-5xl mx-auto" data-id="element-150">
            <h3 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-151">
              Con el Mega Pack Globología Mágica vas a poder:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-152">
              {[{
              text: 'Hacer arcos perfectos sin que se desarmen',
              icon: '🎈'
            }, {
              text: 'Crear figuras infantiles y animales',
              icon: '🦄'
            }, {
              text: 'Armar columnas, flores, personajes y estructuras complejas',
              icon: '🏗️'
            }, {
              text: 'Diseñar mesas de Candy Bar completas',
              icon: '🍬'
            }, {
              text: 'Combinar colores de forma profesional',
              icon: '🎨'
            }, {
              text: 'Presupuestar eventos sin dudar',
              icon: '💰'
            }, {
              text: 'Entregar trabajos profesionales aunque seas principiante',
              icon: '🎓'
            }, {
              text: 'Preparar decoraciones rápidas para trabajos urgentes',
              icon: '⚡'
            }].map((item, i) => <div key={i} className="flex items-start gap-3 bg-purple-50 p-5 rounded-xl border border-purple-100 hover:shadow-md transition-shadow" data-id="element-153">
                  <span className="text-2xl" data-id="element-154">{item.icon}</span>
                  <span className="text-gray-800 font-bold" data-id="element-155">{item.text}</span>
                </div>)}
            </div>
          </div>

          {/* 2) Sección "Qué incluye exactamente" (Nueva) */}
          <div className="mt-20 max-w-6xl mx-auto bg-white rounded-3xl p-8 md:p-12 border-2 border-purple-100 shadow-xl" data-id="element-156">
            <h3 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-157">
              Qué incluye exactamente el Mega Pack Globología Mágica Pro
            </h3>

            {/* Fila superior (3 columnas) */}
            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-158">
              {[{
              icon: <Zap className="w-10 h-10 text-purple-500" data-id="element-159" />,
              title: 'Curso completo de Decoración de Eventos',
              desc: 'Videos + PDF'
            }, {
              icon: <Layout className="w-10 h-10 text-blue-500" data-id="element-160" />,
              title: 'Curso completo de Globología',
              desc: 'Paso a paso'
            }, {
              icon: <Star className="w-10 h-10 text-yellow-500" data-id="element-161" />,
              title: 'Curso completo de Mesas Dulces & Candy Bar',
              desc: 'Técnicas profesionales'
            }].map((item, i) => <div key={i} className="flex flex-col items-center text-center gap-3 p-4 rounded-xl bg-purple-50 border border-purple-100" data-id="element-162">
                  <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-163">
                    {item.icon}
                  </div>
                  <div data-id="element-164">
                    <h4 className="font-bold text-lg text-gray-900 leading-tight" data-id="element-165">
                      {item.title}
                    </h4>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-166">{item.desc}</p>
                  </div>
                </div>)}
            </div>

            {/* Fila inferior (4 columnas) */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-167">
              {[{
              icon: <ShieldCheck className="w-8 h-8 text-green-500" data-id="element-168" />,
              title: 'Negocio rentable',
              desc: 'Cómo presupuestar y cobrar'
            }, {
              icon: <Gift className="w-8 h-8 text-orange-500" data-id="element-169" />,
              title: 'Figuras y personajes',
              desc: 'Animales, flores y muñecos'
            }, {
              icon: <BookOpen className="w-8 h-8 text-pink-500" data-id="element-170" />,
              title: 'Organización',
              desc: 'Guías para gestionar eventos'
            }, {
              icon: <Check className="w-8 h-8 text-indigo-500" data-id="element-171" />,
              title: 'Plantillas y personajes',
              desc: 'Editables en PowerPoint y Canva'
            }].map((item, i) => <div key={i} className="flex flex-col items-center text-center gap-2 p-3 rounded-xl hover:bg-gray-50 transition-colors border border-gray-100" data-id="element-172">
                  <div className="bg-gray-100 p-2 rounded-full" data-id="element-173">
                    {item.icon}
                  </div>
                  <div data-id="element-174">
                    <h4 className="font-bold text-sm md:text-base text-gray-900 leading-tight" data-id="element-175">
                      {item.title}
                    </h4>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-176">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience Section */}
      <section className="py-20 px-4 bg-pink-50" data-id="element-177">
        <div className="max-w-4xl mx-auto" data-id="element-178">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-179">
            Esto es para vos si…
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-180">
            {['Querés empezar desde cero, pero no querés perder tiempo improvisando.', 'Ya decorás eventos, pero no sabés cuánto cobrar.', 'Sentís que te falta orden y seguridad.', 'Querés generar ingresos reales con decoración.', 'Estás cansada de trabajar mucho y ganar poco.', 'Querés sentirte profesional, aunque hoy te sientas amateur.'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-6 rounded-xl shadow-sm border border-pink-100 flex items-center gap-4" data-id="element-181">
                <div className="bg-pink-100 p-2 rounded-full" data-id="element-182">
                  <Heart className="w-5 h-5 text-pink-500" data-id="element-183" />
                </div>
                <p className="font-medium text-gray-700" data-id="element-184">{item}</p>
              </motion.div>)}
          </div>
          <div className="mt-12 text-center" data-id="element-185">
            <p className="text-xl font-medium text-gray-800 mb-8" data-id="element-186">
              No necesitás ser artista. Necesitás un sistema que funcione en la
              vida real.
            </p>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-white to-purple-50 relative overflow-hidden" data-id="element-187">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl" data-id="element-188">
          <div className="bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-white py-3 px-6 text-center font-bold text-sm md:text-base tracking-wide shadow-lg animate-pulse" data-id="element-189">
            🎁 OFERTA ESPECIAL POR TIEMPO LIMITADO
          </div>
        </div>

        <div className="max-w-6xl mx-auto pt-12" data-id="element-190">
          <div className="text-center mb-16" data-id="element-191">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-192">
              Regalos Exclusivos
            </h2>
            <p className="text-xl text-purple-600 font-medium" data-id="element-193">
              Gratis con tu compra hoy
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-194">
            <BonusCard image="https://cdn.magicpatterns.com/uploads/uq8Ym4Ws7WM389REmdubso/Bono_1.png" title="Bono 1: Curso de Diseño Gráfico" description="Aprendé diseño gráfico aplicado al Candy Bar para crear decoraciones profesionales y atractivas." delay={0.1} data-id="element-195" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/15zSeDofzVaY1MudHG297e/Bono_2.png" title="Bono 2: Pack de Instalación" description="Instalador de Corel Draw 2025 y PowerPoint para que empieces a diseñar desde el primer día." delay={0.2} data-id="element-196" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/fowpgJm3akp3d4QM6rtD6Z/Bono_3.png" title="Bono 3: 500 Personajes" description="500 personajes editables para Candy Bar, listos para usar en Canva y PowerPoint." delay={0.3} data-id="element-197" />
          </div>

          <div className="max-w-4xl mx-auto flex justify-center" data-id="element-198">
            <CTAButton data-id="element-199">QUIERO MI MEGA PACK AHORA</CTAButton>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-green-50 to-white" data-id="element-200">
        <div className="max-w-3xl mx-auto" data-id="element-201">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 border-green-200" data-id="element-202">
            <div className="flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-203">
              <div className="bg-green-100 p-6 rounded-full flex-shrink-0" data-id="element-204">
                <ShieldCheck className="w-16 h-16 text-green-600" data-id="element-205" />
              </div>
              <div className="flex-grow" data-id="element-206">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3" data-id="element-207">
                  🛡 Garantía de Satisfacción Sin Preguntas – 7 Días
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-208">
                  Si en los próximos 7 días sentís que el pack no es para vos,
                  te devolvemos tu dinero sin preguntas. Queremos que estés 100%
                  segura de tu decisión.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section (Improved) */}
      <section className="py-20 px-4 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 text-white relative overflow-hidden" data-id="element-209">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-210">
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-211">
            ¿Lista para dejar de improvisar?
          </h2>

          <div className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-lg mx-auto transform hover:scale-105 transition-transform duration-300 relative overflow-hidden" data-id="element-212">
            {/* 3) Bloque de Urgencia Completo */}
            <div className="bg-red-500 text-white font-bold py-2 px-4 mb-6 -mx-8 md:-mx-12 -mt-8 md:-mt-12" data-id="element-213">
              ANTES $49.990 — HOY $19.990 (60% OFF)
            </div>

            <h3 className="text-2xl font-bold mb-6" data-id="element-214">
              Mega Pack Globología Mágica Pro + 3 Bonos
            </h3>

            <div className="flex flex-col items-center justify-center mb-4" data-id="element-215">
              <div className="flex items-center gap-2 mb-1" data-id="element-216">
                <span className="text-gray-400 line-through text-xl" data-id="element-217">
                  $49.990
                </span>
                <span className="bg-green-100 text-green-700 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-218">
                  60% OFF
                </span>
              </div>
              <div className="flex items-start" data-id="element-219">
                <span className="text-3xl font-bold mt-2" data-id="element-220">$</span>
                <span className="text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600" data-id="element-221">
                  19.990
                </span>
                <span className="text-xl font-bold mt-8 ml-1 text-gray-500" data-id="element-222">
                  ARS
                </span>
              </div>
              <p className="text-sm text-gray-500 font-medium mt-2" data-id="element-223">
                Pago único · Sin mensualidades
              </p>
            </div>

            <CTAButton fullWidth className="animate-pulse" data-id="element-224">
              QUIERO MI MEGA PACK AHORA
            </CTAButton>

            <p className="text-xs text-red-500 font-bold mt-3 animate-pulse" data-id="element-225">
              ¡Atención! El precio sube cuando termine el contador.
            </p>

            {/* 7) Logo Mercado Libre Grande */}
            <div className="mt-8 flex flex-col items-center gap-3" data-id="element-226">
              <div className="flex items-center gap-2 text-sm font-bold text-gray-700 bg-gray-50 px-4 py-2 rounded-full border border-gray-100" data-id="element-227">
                <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-228" />
                <span data-id="element-229">Pago procesado de forma 100% segura por:</span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/va8bEbwnWYe2Vz54Fj7g7U/mercado.png" alt="Mercado Libre" className="h-12 object-contain" data-id="element-230" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 px-4 bg-white" data-id="element-231">
        <FAQ data-id="element-232" />
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-233">
        <div className="max-w-6xl mx-auto" data-id="element-234">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-235">
            Ellas ya están facturando con sus eventos
          </h2>
          <div className="flex justify-center mb-12" data-id="element-236">
            <span className="bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-2 animate-pulse" data-id="element-237">
              👀 124 personas están viendo esta página ahora
            </span>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-238">
            <TestimonialCard name="Mariana G." location="Salta, Argentina" text="Antes me daba pánico pasar un presupuesto. Con el método del pack, ahora sé exactamente cuánto cobrar. ¡Recuperé la inversión en mi primer evento!" tag="Más ingresos" delay={0.1} data-id="element-239" />
            <TestimonialCard name="Lucía R." location="Mendoza, Argentina" text="Los bonos son increíbles. No sabía nada de diseño y con el curso de regalo pude armar mis propias etiquetas. Mis mesas quedaron hermosas." tag="Eventos más prolijos" delay={0.2} data-id="element-240" />
            <TestimonialCard name="Carolina M." location="Rosario, Santa Fe" text="Lo que más me sirvió fue la parte de organización. Vivía corriendo a último momento. Ahora tengo todo planificado." tag="Más seguridad" delay={0.3} data-id="element-241" />
            <TestimonialCard name="Valentina S." location="CABA, Buenos Aires" text="Empecé sin saber inflar un globo. Las explicaciones son súper claras. Ya hice 3 cumpleaños y todos quedaron encantados." tag="Ideal principiantes" delay={0.4} data-id="element-242" />
            <TestimonialCard name="Sofía L." location="La Plata, Buenos Aires" text="Llevaba años decorando pero sentía que mis trabajos se veían 'caseros'. Con las técnicas de estructuras prolijas, mis arcos ahora parecen de revista." tag="Más clientes" delay={0.5} data-id="element-243" />
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 px-4 bg-white text-center" data-id="element-244">
        <div className="max-w-3xl mx-auto" data-id="element-245">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-246">
            No es magia. Es un sistema.
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-247">
            Mega Pack Globología Mágica Pro no promete resultados irreales.
            Promete algo mejor: orden, claridad y un método que se puede
            repetir.
          </p>
          <p className="text-lg font-bold text-purple-700 mb-10" data-id="element-248">
            Y los sistemas se repiten. Se cobran. Y se pueden hacer crecer.
          </p>

          <div className="mb-10 text-center" data-id="element-249">
            <p className="text-xl md:text-2xl font-bold text-purple-800 leading-relaxed" data-id="element-250">
              "No es un curso de globos. Es un sistema para dejar de improvisar
              eventos y empezar a cobrar como profesional."
            </p>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-251">
            <CTAButton className="text-2xl px-12 py-6" data-id="element-252">
              👉 QUIERO EL PACK AHORA
            </CTAButton>
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-253">
              <Gift className="w-4 h-4" data-id="element-254" />
              <span data-id="element-255">Incluye los 3 bonos gratis hoy</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-256">
        <p data-id="element-257">
          © 2024 Mega Pack Globología Mágica Pro. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-258">
          Este producto no garantiza resultados económicos. El éxito depende de
          tu dedicación y esfuerzo.
        </p>
      </footer>
    </div>;
}